export function getNameInitials(name: string): string {
  if (name === '') {
    return '';
  }
  const nameParts = name.trim().split(' ');

  return `${nameParts[0]?.[0] ?? ''}${nameParts[1]?.[0] ?? ''}`;
}
